module.exports = __webpack_public_path__ + "media/newstyle/images/icon-image-gallery-e19a1e13d1a1e1d488b6c78bce75d1ba.svg";